import React from 'react';
import BtcIcon from './icons/BtcIcon';

const LoadingScreen: React.FC = () => {
  return (
    <div className="min-h-screen bg-dark-blue flex flex-col items-center justify-center text-center">
      <div className="flex items-center justify-center mb-6">
        <BtcIcon className="w-16 h-16 mr-4 animate-pulse" />
        <h1 className="text-4xl font-bold text-off-white tracking-tight">BTC Gain & Loss</h1>
      </div>
      <p className="text-xl text-light-blue">Fetching latest market data...</p>
    </div>
  );
};

export default LoadingScreen;
